import { render, staticRenderFns } from "./AppInputTextarea.vue?vue&type=template&id=6029c6db&scoped=true&"
import script from "./AppInputTextarea.vue?vue&type=script&lang=js&"
export * from "./AppInputTextarea.vue?vue&type=script&lang=js&"
import style0 from "./AppInputTextarea.vue?vue&type=style&index=0&id=6029c6db&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6029c6db",
  null
  
)

export default component.exports